import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { fetchBookings } from '../redux/slice/bookingSlice';

export const useFetch = (pageNumber) => {
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchDataAndSelect = async () => {
      await dispatch(fetchBookings({page : pageNumber}));
    };

    fetchDataAndSelect();
  }, [pageNumber, dispatch]);
};
